<template>
    <div class='boxlog' id="boxlog">
        <!-- 筛选 -->
        <!-- <h3 class="flex-row-start" style="margin-top: 0">条件筛选</h3> -->

        <el-form @submit.native.prevent label-width='50px'>
            <el-row>
                <el-col :span="6">
                    <el-form-item label='日期:'>
                        <el-date-picker size="small" v-model="date" align="right" format="yyyy-MM-dd"
                            @change='getBoxlog();' :editable='false' :clearable='false'
                            style="margin-left: 10px">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span='6' :offset="2">
                    <el-form-item label='检索:'>
                        <el-input v-model="keyword" size="small" @change="search" @keydown.enter="search">
                            <template slot="append">
                                <div style="cursor: pointer">搜索</div>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :span='8' :offset="2">
                    <el-button-group>
                        <el-button size='small' :type="showtype == 'all' ? 'primary' : ''"
                            @click="onTypeChange('all')">所有日志</el-button>
                        <el-button size='small' :type="showtype == 'ble' ? 'primary' : ''"
                            @click="onTypeChange('ble')">BLE数据</el-button>
                        <el-button size='small' :type="showtype == 'ant' ? 'primary' : ''"
                            @click="onTypeChange('ant')">ANT数据</el-button>
                        <el-button size='small' :type="showtype == 'udp' ? 'primary' : ''"
                            @click="onTypeChange('udp')">UDP数据</el-button>
                    </el-button-group>
                </el-col> -->
            </el-row>
        </el-form>

        <i class="el-icon-arrow-up arrow-up" @click="scrollUp"></i>

        <div class="flex-row-between">
            <h3 width='100px'>盒子编号：{{ boxsn }}</h3>
            <el-button type="primary" plain @click="showLog">盒子日志</el-button>
        </div>
         <!-- 盒子基本信息 -->
         <h3 width='100px'>盒子基本信息</h3>
        <el-table :data='basic_summary' style='width: 100%' header-cell-class-name='myth' cell-class-name='mytd'
            v-loading="loading" size='medium' :expand-row-keys='expandKey' :row-key='row => row.id'
            ref="lessonrecord-table">
            <el-table-column prop="device_number" label="设备编号" />
            <el-table-column prop='venue_name' label="场馆名称" />
            <el-table-column prop="version" label="盒子版本" />
            <el-table-column prop='first_used_day' label="首次使用时间" />
            <el-table-column label="蓝牙">
                <template slot-scope="scope">
                    {{ scope.row.bluetooth == 1 ? '开启' : '关闭' }}
                </template>
            </el-table-column>
            <el-table-column label="天线">
                <template slot-scope="scope">
                    {{ scope.row.antenna == 1 ? '开启' : '关闭' }}
                </template>
            </el-table-column>
            <el-table-column label="主题">
                <template slot-scope="scope">
                    {{ scope.row.theme == 1 ? '开启' : '关闭' }}
                </template>
            </el-table-column>
            <el-table-column prop='last_online' label="最后在线时间" />
        </el-table>
        <!-- 盒子当前状态 -->
        <h3 width='100px'>盒子工作状态</h3>
        <el-table :data='current_status' stripe style='width: 100%' border header-cell-class-name='myth'
            cell-class-name='mytd' v-loading="loading" size='small'>
            <el-table-column prop="bluetooth_scanner" label='蓝牙扫描状态' />
            <el-table-column prop='antenna_scanner' label='天线扫描状态' />
            <el-table-column prop="udp_scanner" label='UDP扫描状态' />
            <el-table-column prop="initbox_total_record" label='开机次数' />
            <el-table-column prop="first_create_dt" label='首次开机时间' />
            <el-table-column prop="last_time" label='最后时间' />
        </el-table>
        <!-- 当前盒子上课信息 -->
        <h3 width='100px'>盒子上课信息</h3>
        <div class="course_list">
            <div class="course_item" v-for="item in course" :key="item.label">
                <div class="course_item_title">
                    <span>课程id: {{ item.id }}</span>
                    <span>课程类型: {{ item.kind_no }} ({{ item.kind_no_name }})</span>
                    <span>课程教练: {{ item.coach_name }}</span>
                    <span>学员人数：{{ item.user_num }}</span>
                    <span>课程创建时间：{{ item.create_dt }}</span>
                    <span>课程当前状态：{{ item.status_no }}</span>
                </div>

                <el-table :data='item.customers' stripe style='width: 100%' border header-cell-class-name='myth'
                    cell-class-name='mytd' v-loading="loading" size='small'>
                    <el-table-column prop="session_id" label='课程id' width="100px" />
                    <el-table-column prop="customer_name" label='学员名称' />
                    <el-table-column label='用户头像' width="70px">
                        <template slot-scope="scope">
                            <img :src="scope.row.customer_icon_url" alt="" style="width: 30px; height: 30px; border-radius: 50%;">
                        </template>
                    </el-table-column>
                    <el-table-column label='性别' width="50px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.customer_sex == 1 ? '男' : '女' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customer_birthday" label='生日' width="100px" />
                    <el-table-column prop="in_venue_no" label='场馆内编码' width="100px" />
                    <el-table-column prop="hr_sensor_sn" label='设备sn' width="100px" />
                    <!-- <el-table-column prop="group_name" label='PK组名' /> -->
                    <el-table-column prop="calories_value" label='卡路里' width="100px" />
                    <el-table-column prop="ck_value" label='CK' width="70px" />
                    <el-table-column prop="create_dt" label='加入时间' />
                    <el-table-column prop="end_dt" label='退出时间' />
                    <el-table-column prop="class_duration" label='上课时长' />
                    <el-table-column prop="heart_rate_value" label='心率数据' />
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import { post } from '@/utils/http'

export default {
    data() {
        return {
            basic_summary: [],
            loading: false,
            boxsn: this.$route.params.boxsn,
            date: new Date(),
            current_status: [],
            course: []
        }
    },
    mounted() {
        if (!this.boxsn) {
            this.$rouer.push('/boxlist')
        }
        this.getBoxlog();
    },
    methods: {
        showLog() {
            this.$router.push("/boxlog/" + this.boxsn);
        },
        /* search() {
            this.loading = true
            setTimeout(() => {
                this.showdata = this.keyword ? this.boxlog.filter(b => b.cmd == this.keyword) : this.boxlog
            }, 0);
            setTimeout(() => {
                this.loading = false
            }, 500);
        }, */
        scrollUp() {
            window.scrollTo(0, 0)
        },
        async getBoxlog() {
            this.loading = true
            this.keyword = ''
            this.basic_summary = [];
            this.current_status = [];
            this.course = [];
            let y = this.date.getFullYear()
            let m = this.date.getMonth() + 1
            m = ('00' + m).substr(-2)
            let d = this.date.getDate()
            d = ('00' + d).substr(-2)
            const data = {
                sn: this.boxsn,
                date: y + '-' + m + '-' + d
            }
            try {
                const res = await post('/box/Index/getBoxStatistics', data);
                /* const res = {
                    rst: 0,
                    msg: '查询成功',
                    data: {
                        basic_summary: {
                            device_number: '527976',
                            venue_name: '慕浠瑜伽',
                            version: '6.6.1',
                            first_used_day: '2025-07-04 11:31:46',
                            bluetooth: 1,
                            antenna: 1,
                            theme: 1,
                            last_online: '2025-07-01 00:00:00'
                        },
                        current_status: {
                            bluetooth_scanner: '2025-07-01 12:28:07(已停止工作)',
                            antenna_scanner: '2025-07-01 12:28:07(工作正常)',
                            udp_scanner: '单盒子'
                        },
                        course: [
                            {
                                label: '私教课1',
                                type: 'private',
                                course_num: '10节',
                                user_num: '10人',
                                customers: [
                                    {
                                        name: '张三(10)',
                                        id: '800201020',
                                        class_duration: '42min(08:20 - 12:19)',
                                        heart_rate_value: '3030次(完整率:84%)',
                                        calories_value: '239CLE',
                                        ck_value: '8.2CK',
                                        extend: {
                                            birthday: '2025-01-02'
                                        }
                                    },
                                    {
                                        name: '李四(11)',
                                        id: '800201023',
                                        class_duration: '39min(08:20 - 12:19)',
                                        heart_rate_value: '3030次(完整率:84%)',
                                        calories_value: '239CLE',
                                        ck_value: '8.2CK',
                                        extend: {
                                            birthday: '2025-08-12'
                                        }
                                    }
                                ]
                            },
                            {
                                label: '私教课2',
                                type: 'private',
                                course_num: '10节',
                                user_num: '10人',
                                customers: [
                                    {
                                        name: '张三(10)',
                                        id: '800201020',
                                        class_duration: '42min(08:20 - 12:19)',
                                        heart_rate_value: '3030次(完整率:84%)',
                                        calories_value: '239CLE',
                                        ck_value: '8.2CK',
                                        extend: {
                                            birthday: '2025-01-02'
                                        }
                                    },
                                    {
                                        name: '李四(11)',
                                        id: '800201023',
                                        class_duration: '39min(08:20 - 12:19)',
                                        heart_rate_value: '3030次(完整率:84%)',
                                        calories_value: '239CLE',
                                        ck_value: '8.2CK',
                                        extend: {
                                            birthday: '2025-08-12'
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                } */
                if (res.rst == 0) {
                    // 获取基本信息并转化为数组
                    this.basic_summary.push(res.data.basic_summary);
                    // 获取当前状态并转化为数组
                    this.current_status.push(res.data.current_status);
                    // 获取当前上课列表
                    this.course = res.data.course;   
                }
                this.loading = false

            } catch (err) {
                this.loading = false
            }
        },
    }
}
</script>

<style lang="less" scoped>
.boxlog {
    .arrow-up {
        position: fixed;
        bottom: 64px;
        right: 32px;
        z-index: 999;
        color: #409EFF;
        font-size: 40px;
        font-weight: 700;
        cursor: pointer;
    }

    .device-hr-detail {
        width: 100%;
        overflow: scroll;
    }

    .device-hr-detail::-webkit-scrollbar {
        display: none;
    }
}

.course_list{
    height: 500px;
}
.course_item_title {
    display: flex;
    align-items: center;
    background: #f5f7fa;
    border-left: 4px solid #409EFF;
    padding: 8px 16px;
    margin-bottom: 8px;
    font-weight: 500;
    color: #303133;
    border-radius: 4px;
    font-size: 15px;
    gap: 24px;
}
.course_item_title span:first-child {
    color: #409EFF;
    font-size: 16px;
    font-weight: bold;
    margin-right: 16px;
}
</style>